import { Text } from "@mantine/core";

interface ReportPhotoCaptionProps {
  caption?: string;
  metadata: string;
}

export function ReportPhotoCaption(props: ReportPhotoCaptionProps) {
  const { caption, metadata } = props;
  if (!metadata) return <></>;
  return (
    <Text
      data-report-image-caption={caption || undefined}
      size="xs"
      c="dimmed"
      ta="center"
      mt={4}
    >
      {metadata}
    </Text>
  );
}
